import { useSyncExternalStore } from 'react';
import { useOffice } from '@components/OfficeLoader';

import { isInIframe } from './helpers';

const emptySubscribe = () => () => { };
const useIsEmbed = (): boolean => {
  const { isPowerpoint } = useOffice();
  const inIframe = useSyncExternalStore(
    emptySubscribe,
    () => isInIframe(),
    () => false,
  );

  return Boolean(isPowerpoint) || inIframe;
};

export default useIsEmbed;
